<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="p-card-field">
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Type of post <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <div class="p-field p-grid">
              <div class="p-col">
                <input class="input_tmp_validator" id="type_post_id_va">
                <Dropdown class="p-col-width-a" disabled v-model="type_post" :options="list_type_post"
                  optionValue="id" optionLabel="label" placeholder="Select"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="type_post == 'LOOKING_FOR_A_TEAM'">
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Club name</label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <InputText disabled v-model="clubs_name" id="clubs_name" type="text" class="p-col-width-a" placeholder="Input" />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Date & Time</label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <label style="margin-right: 10px;">
                <Calendar id="time11" style="width:200px !important" disabled v-model="date_start" :showIcon="true" dateFormat="M dd, yy"/>
              </label>
              <label>
                <Calendar id="time12" style="width:200px !important" disabled v-model="time_start" :timeOnly="true" hourFormat="12" :showIcon="true" icon="pi pi-clock" />
              </label>  
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Stadium <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <InputText disabled v-model="stadium_name" id="stadium_name" type="text" class="p-col-width-a" placeholder="" />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">P v P <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Dropdown class="p-col-width-a" disabled v-model="number_of_player_id" :options="list_number_of_player"
                optionValue="id" optionLabel="label" placeholder="Select"
              />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Gender <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Dropdown class="p-col-width-a" disabled v-model="gender" :options="list_gender"
                optionValue="id" optionLabel="label" placeholder="Select"
              />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Participation fee <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <label style="margin-right: 10px;">
                <InputNumber style="max-width:500px" id="participation_fee" v-model="participation_fee" mode="decimal" :minFractionDigits="2" locale="en-US" placeholder=""></InputNumber>
              </label>
              <label>
                <Dropdown style="width:100px" class="p-col-width-a" v-model="currency_code" :options="list_currency"
                  optionValue="id" optionLabel="label" placeholder="Select"
                />
              </label>  
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Caption <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Textarea v-model="caption" id="caption" rows="5" class="p-col-width-a"/>
            </div>
          </div>
        </div>

        <div v-else-if="type_post == 'LOOKING_FOR_MERCENARY'">
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Club name</label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <InputText disabled v-model="clubs_name" id="clubs_name" type="text" class="p-col-width-a" placeholder="Input" />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Date & Time</label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <label style="margin-right: 10px;">
                <Calendar id="time11" style="width:200px !important" disabled v-model="date_start" :showIcon="true" dateFormat="M dd, yy"/>
              </label>
              <label>
                <Calendar id="time12" style="width:200px !important" disabled v-model="time_start" :timeOnly="true" hourFormat="12" :showIcon="true" icon="pi pi-clock" />
              </label>  
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Stadium <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <InputText disabled v-model="stadium_name" id="stadium_name" type="text" class="p-col-width-a" placeholder="" />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Number of mercenary <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Dropdown class="p-col-width-a" disabled v-model="number_of_mercenary" :options="list_number_of_mercenary"
                optionValue="id" optionLabel="label" placeholder="Select"
              />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">P v P <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Dropdown class="p-col-width-a" disabled v-model="number_of_player_id" :options="list_number_of_player"
                optionValue="id" optionLabel="label" placeholder="Select"
              />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Gender <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Dropdown class="p-col-width-a" disabled v-model="gender" :options="list_gender"
                optionValue="id" optionLabel="label" placeholder="Select"
              />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Participation fee <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <label style="margin-right: 10px;">
                <InputNumber disabled style="max-width:500px" id="participation_fee" v-model="participation_fee" mode="decimal" :minFractionDigits="2" locale="en-US" placeholder=""></InputNumber>
              </label>
              <label>
                <Dropdown disabled style="width:100px" class="p-col-width-a" v-model="currency_code" :options="list_currency"
                  optionValue="id" optionLabel="label" placeholder="Select"
                />
              </label>  
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Opponent</label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Dropdown class="p-col-width-a" disabled v-model="opponent" :options="list_opponent"
                optionValue="id" optionLabel="name" placeholder="Select"
              />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Caption <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Textarea v-model="caption" id="caption" rows="5" class="p-col-width-a"/>
            </div>
          </div>
        </div>

        <div v-else-if="type_post == 'SCOUT_CLUB_TEAM_MEMBER'">
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Club name</label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <InputText disabled v-model="clubs_name" id="clubs_name" type="text" class="p-col-width-a" placeholder="Input" />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Title <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <InputText v-model="title" id="title" type="text" maxlength="255" class="p-col-width-a" placeholder="Input" />
            </div>
          </div>
          
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Number of people needed to scout <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Dropdown class="p-col-width-a" v-model="number_recruit" :options="list_number_recruit"
                optionValue="id" optionLabel="label" placeholder="Select"
              />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Gender <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Dropdown class="p-col-width-a" v-model="gender" :options="list_gender"
                optionValue="id" optionLabel="label" placeholder="Select"
              />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Participation fee <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <label style="margin-right: 10px;">
                <InputNumber style="max-width:500px" id="participation_fee" v-model="participation_fee" mode="decimal" :minFractionDigits="2" locale="en-US" placeholder=""></InputNumber>
              </label>
              <label>
                <Dropdown style="width:100px" class="p-col-width-a" v-model="currency_code" :options="list_currency"
                  optionValue="id" optionLabel="label" placeholder="Select"
                />
              </label>  
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Schedule <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Dropdown class="p-col-width-a" v-model="schedule" :options="list_schedule"
                optionValue="id" optionLabel="label" placeholder="Select"
              />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Operating time <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <input class="input_tmp_validator" id="operating_time_va">
              <Dropdown class="p-col-width-a" v-model="operating_time" :options="list_operating_time"
                optionLabel="name" placeholder="Choose" @change="ChangeOperating"
              />
            </div>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <label v-for="(operating, index) in operating_time_show" :key="index" class="cus-tags">
                <span class="cs-tag">
                  {{operating.name}}
                </span>
                <i class="fas fa-times cs-icon" v-on:click="removeOperating(index)"></i>
              </label>
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">About club</label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Textarea v-model="about_club" id="about_club" rows="5" class="p-col-width-a"/>
            </div>
          </div>
        </div>

        <div v-else-if="type_post == 'APPLYING_TO_JOIN'">
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Title <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <InputText v-model="title" id="title" type="text" maxlength="255" class="p-col-width-a" placeholder="Input" />
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Age <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <InputNumber id="age" v-model="age" locale="en-US" placeholder="" :min="1" :max="100" class="p-col-width-a"></InputNumber>
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Gender <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Dropdown class="p-col-width-a" v-model="gender" :options="list_gender"
                optionValue="id" optionLabel="label" placeholder="Select"
              />
            </div>
          </div>
          <div class="p-field p-grid in-d">
            <label class="p-col-fixed">MAIN ACTIVE AREA</label>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Country</label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <div class="p-field p-grid">
                <div class="p-col">
                  <input class="input_tmp_validator" id="country_id_va">
                  <Dropdown class="p-col-width-a" v-model="country_id" :options="list_country"
                    optionValue="id" optionLabel="name" placeholder="Select" v-on:change="listProvice('change_country')"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">City/Provine <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <div v-on:click="showMainActive" class="p-col-width-a">
                <input class="input_tmp_validator" id="province_city_va">
                <Dropdown class="p-col-width-a" placeholder=""/>
              </div>
            </div>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <label v-for="(area, index) in main_active_area" :key="index" class="cus-tags">
                <span class="cs-tag">
                  {{area.label}}
                </span>
                <i class="fas fa-times cs-icon" v-on:click="removeAreas(index)"></i>
              </label>
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Operating time <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <input class="input_tmp_validator" id="operating_time_va">
              <Dropdown class="p-col-width-a" v-model="operating_time" :options="list_operating_time"
                optionLabel="name" placeholder="Choose" @change="ChangeOperating"
              />
            </div>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <label v-for="(operating, index) in operating_time_show" :key="index" class="cus-tags">
                <span class="cs-tag">
                  {{operating.name}}
                </span>
                <i class="fas fa-times cs-icon" v-on:click="removeOperating(index)"></i>
              </label>
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">About yourself</label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Textarea v-model="about_yourself" id="about_yourself" rows="5" class="p-col-width-a"/>
            </div>
          </div>
        </div>

        <div v-if="type_post == 'POST_ON_MY_CLUB'">
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Club name</label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <InputText disabled v-model="clubs_name" id="clubs_name" type="text" class="p-col-width-a" placeholder="Input" />
            </div>
          </div>
          <div v-if="attendance_check == true">
            <div class="p-field p-grid">
              <label class="p-col-fixed in-d">Match <span style="color:red">*</span></label>
            </div>
            <div class="p-field p-grid">
              <div class="p-col">
                <Dropdown class="p-col-width-a" disabled v-model="match" :options="list_match"
                  optionLabel="label" placeholder="Select"
                />
              </div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-fixed in-d">Date & Time <span style="color:red">*</span></label>
            </div>
            <div class="p-field p-grid">
              <div class="p-col">
                <label style="margin-right: 10px;">
                  <Calendar id="time11" style="width:200px !important" disabled v-model="date_start" :showIcon="true" dateFormat="M dd, yy"/>
                </label>
                <label>
                  <Calendar id="time12" style="width:200px !important" disabled v-model="time_start" :timeOnly="true" hourFormat="12" :showIcon="true" icon="pi pi-clock" />
                </label>  
              </div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-fixed in-d">Stadium <span style="color:red">*</span></label>
            </div>
            <div class="p-field p-grid">
              <div class="p-col">
                <InputText disabled v-model="stadium_name" id="stadium_name" type="text" class="p-col-width-a" placeholder="" />
              </div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-fixed in-d">Number of player <span style="color:red">*</span></label>
            </div>
            <div class="p-field p-grid">
              <div class="p-col">
                <Dropdown class="p-col-width-a" disabled v-model="number_of_player_id" :options="list_number_of_player"
                  optionValue="id" optionLabel="label" placeholder="Select"
                />
              </div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-fixed in-d">Opponent <span style="color:red">*</span></label>
            </div>
            <div class="p-field p-grid">
              <div class="p-col">
                <Dropdown class="p-col-width-a" disabled v-model="opponent" :options="list_opponent"
                  optionValue="id" optionLabel="name" placeholder="Select"
                />
              </div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-fixed in-d">Gender <span style="color:red">*</span></label>
            </div>
            <div class="p-field p-grid">
              <div class="p-col">
                <Dropdown class="p-col-width-a" disabled v-model="gender" :options="list_gender"
                  optionValue="id" optionLabel="label" placeholder="Select"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="type_post == 'SHOWING_OFF_YOUR_EQUIPMENT'">
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Caption </label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Textarea v-model="caption" id="caption" rows="5" class="p-col-width-a"/>
            </div>
          </div>
          
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Tag</label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <vue-tags-input
                v-model="tag"
                :tags="tags"
                @tags-changed="newTags => tags = newTags"
                class="cus-vue-tags-input"
                placeholder=""
              />
            </div>
          </div>
        </div>
        
        <div v-if="type_post == 'LIFE' || type_post == 'MATCH' || type_post == 'QUESTION'">
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Caption </label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Textarea v-model="caption" id="caption" rows="5" class="p-col-width-a"/>
            </div>
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Images ({{img_club.length}}/10)</label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <div class="p-col-width disabled">
              <label class="file-select">
                <div class="select-button">
                  <span >Browse...</span>
                </div>
                <input accept="image/*" multiple name="images[]" type="file" @change="onFileSelect"/>
              </label>
            </div>
            <input class="input_tmp_validator" id="image_va">
            <div class="cus-text">- Accepted: PNG, JPG, JPEG, GIF.</div>
            <div class="cus-text">- Recommended: 800x450px</div>
            <div class="cus-text">- Maximum upload file size: 500 MB</div>
            <div class="box-images p-grid"  v-if="img_club && img_club.length">
              <div class="item-img p-col-5" v-for="(item, index) in img_club" :key="index" >
                <div class="button-clear" @click="onFileClear(index,'img_club')"><img :src="require('../../../assets/ic_clear.svg')"/></div>
                <img :src="item.objectURL"/>
              </div>
            </div>
          </div>
        </div>
        <div v-if="type_post == 'POST_ON_MY_CLUB'">
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d">Caption </label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <Textarea v-model="caption" id="caption" rows="5" class="p-col-width-a"/>
            </div>
          </div>
        </div>

        <div class="p-field in-d">
          <label >
            <div class="container">
              <input v-if="active==true" type="checkbox" class="cus-checkbox" checked="checked" v-on:change="funtionUpdate($event)">
              <input v-else type="checkbox" class="cus-checkbox" v-on:change="funtionUpdate($event)">
              <span class="checkmark"></span>
              <span>Show</span>
            </div>
          </label>
        </div>      
      </div>
    
      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning"
            style="width: 120px !important;"
          />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success"
            style="width: 120px !important;"

          />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success"
            style="width: 120px !important;"
          />
        </template>
      </Toolbar>
      <Dialog
        header="Choose main active area - City"
        :visible.sync="showChooseMain"
        :modal="true"
        class="cusss"
      >
        <table id="table_1" style="overflow-x: auto;border-collapse: collapse;">
          <tr>
            <td class="custom-div container-1">
              <label class="cus-lab">
                <input type="checkbox" class="cus-checkbox" :checked="checkAllProvince ? true: false" v-on:change="funtionProvinceCheckAll($event)">
                <span class="checkmark1"></span>
                <span class="cs-tag" style="font-weight: 500;">
                  All
                </span>
              </label>
            </td>
          </tr>
          <tr v-for="(province, index) in list_province" :key="index" v-bind:class="[province.total_choose > 0 ? 'class-tr' : '']">
            <td class="custom-div container-1">
              <label class="cus-lab">
                <input type="checkbox" class="cus-checkbox" :checked="province.total_choose > 0 ? true: false" v-on:change="funtionProvince($event,index)">
                <span class="checkmark1"></span>
                <span class="cs-tag" style="font-weight: 500;" v-bind:class="[province.total_choose > 0 ? 'text-cus' : '']">
                  {{province.name}}
                </span>
              </label>
              <div class="cs-text-right">
                <span v-bind:class="[province.total_choose > 0 ? 'text-cus' : '']">({{province.total_choose}}/{{province.total}})</span>
                <i class="fas fa-cog cs-icon-right" v-on:click="ShowDistrict(index,province.total_choose,province.total)"></i>
              </div>
            </td>
          </tr>
        </table>
        <template #footer>
          <Button
            label="Cancel"
            @click="showChooseMain = false"
            class="p-button-warning"
          />
          <Button label="Save" @click="SaveArea()" class="p-button-danger" />
        </template>
      </Dialog>
      <Dialog
        header="Choose main active area - District"
        :visible.sync="showChooseMainDistrict"
        :modal="true"
        class="cusss"
      >
        <table id="table_1" style="overflow-x: auto;border-collapse: collapse;">
          <tr>
            <td class="custom-div container-1">
              <label class="cus-lab">
                <input type="checkbox" class="cus-checkbox" :checked="checkAllDistrict ? true: false" v-on:change="funtionDistrictCheckAll($event)">
                <span class="checkmark1"></span>
                <span class="cs-tag" style="font-weight: 500;">
                  All
                </span>
              </label>
            </td>
          </tr>
          <tr v-for="(district, index) in list_district" :key="index" v-bind:class="[district.check==true ? 'class-tr' : '']">
            <td class="custom-div container-1">
              <label class="cus-lab">
                <input type="checkbox" class="cus-checkbox" :checked="district.check ? district.check : false" v-on:change="funtionDistrict($event,index)">
                <span class="checkmark1"></span>
                <span class="cs-tag" style="font-weight: 500;" v-bind:class="[district.check==true ? 'text-cus' : '']">
                  {{district.name}}
                </span>
              </label>
            </td>
          </tr>
        </table>
        <template #footer>
          <Button
            label="Cancel"
            @click="CancelDistrict()"
            class="p-button-warning"
          />
          <Button label="Save" @click="Savedistrict()" class="p-button-danger" />
        </template>
      </Dialog>
    </div>
  </form>
  
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
// import gql from "graphql-tag";
import VueTagsInput from '@johmun/vue-tags-input';
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
    id: String,
  },
  components: {
    VueTagsInput,
  },
  data() {
    return {
      time_zone_local : moment.tz.guess(),
      showChooseMain : false,
      showChooseMainDistrict : false,
      account_exist : false,
      validationErrors: {},
      formMode: this.mode,
      active : true,
      list_experience:[],
      country_id : null,
      list_district: [],
      list_country:[],
      list_province:[],
      list_province_last: [],
      checkAllProvince : false,
      checkAllProvince_old : false,
      checkAllDistrict: false,
      total_province: 0,
      total_province_choose: 0,
      total_district_choose : 0,
      province_id_main : 0,
      main_active_area: [],
      list_district_old : [],
      list_type_post : [
        { id: 'LOOKING_FOR_A_TEAM', label: 'Opponent'},
        { id: 'LOOKING_FOR_MERCENARY', label: 'Mercenary'},
        { id: 'SCOUT_CLUB_TEAM_MEMBER', label: 'Scout'},
        { id: 'APPLYING_TO_JOIN', label: 'Join club'},
        { id: 'POST_ON_MY_CLUB', label: 'Only my club'},
        { id: 'MATCH', label: 'Match'},
        { id: 'LIFE', label: 'Posts'},
        { id: 'SHOWING_OFF_YOUR_EQUIPMENT', label: 'Equipment'},
        { id: 'QUESTION', label: 'Question'},
      ],
      type_post : null,
      clubs_name : '',
      time_start : null,
      date_start : null,
      stadium_name : '',
      title : '',
      list_number_of_player : [],
      number_of_player_id : null,
      list_gender : [
        {id : 1, label :  'Male'},
        {id : 2, label :  'Female'},
        {id : 3, label :  'Mix'},
      ],
      gender : null,
      list_currency : [{id : 'USD', label : 'USD'},{id : 'KRW', label : 'KRW'},{id : 'VND', label : 'VND'}],
      currency_code : null,
      participation_fee : null,
      caption : '',
      maxFileSize: 524288000 , // 500MB
      maxFiles : 10,
      img_club : [],
      img_club_deleted : [],
      list_number_of_mercenary: [
        {id:1 , label: 1},{id:2 , label: 2},{id:3, label: 3},{id:4 , label: 4},
        {id:5 , label: 5},{id:6 , label: 6},{id:7 , label: 7},{id:8 , label: 8},
        {id:9 , label: 9},{id:10 , label: 10},{id:11 , label: 11}
      ],
      number_of_mercenary : 1,
      list_opponent : [],
      opponent : null,
      list_number_recruit : [
        {id:1 , label: 1},{id:2 , label: 2},{id:3, label: 3},{id:4 , label: 4},
        {id:5 , label: 5},{id:6 , label: 6},{id:7 , label: 7},{id:8 , label: 8},
        {id:9 , label: 9},{id:10 , label: 10},{id:11 , label: 11}
      ],
      number_recruit:null,
      schedule : null,
      list_schedule : [{id: 'TIME',label: 'Every time'},{id: 'WEEK',label: 'Every week'},{id: 'MONTH',label: 'Every month'},{id: 'YEAR',label: 'Every year'}],
      about_club : '',
      list_operating_time : [],
      operating_time : null,
      operating_time_show: [],
      age : 1,
      about_yourself : '',
      attendance_check : false,
      list_match : [],
      match : null,
      tag: '',
      tags: [],
    }
  },
  async mounted() {
    // await this.listExperience();
    // await this.listCountry();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      // console.log("this.modelthis.model:this.model",this.model)
      this.type_post = this.model.type
      switch (this.model.type) {
        case 'LOOKING_FOR_A_TEAM':
          this.listNumaberOfPlayer();
          if(this.model.clubs){
            this.clubs_name = this.model.clubs.club_name
          }
          if(this.model.match){
            if(this.model.match.stadium){
              this.stadium_name = this.model.match.stadium.name
            }
            this.number_of_player_id = this.model.match.number_of_player_id
            this.gender = this.model.match.gender
            if(this.model.match.date_time){
              // var tmp_date = moment.tz(this.model.match.date_time, this.time_zone_local)
              let tmp_time = new Date(this.model.match.date_time);
              this.date_start = tmp_time
              this.time_start = tmp_time
            }
            this.currency_code = this.model.currency_code
            this.participation_fee = this.model.participation_fee
          }
          this.caption = this.model.caption
          break;
        case 'LOOKING_FOR_MERCENARY':
          this.listNumaberOfPlayer();
          this.number_of_mercenary = this.model.number_of_mercenary
          if(this.model.clubs){
            this.clubs_name = this.model.clubs.club_name
          }
          if(this.model.match){
            if(this.model.match.stadium){
              this.stadium_name = this.model.match.stadium.name
            }
            this.number_of_player_id = this.model.match.number_of_player_id
            this.gender = this.model.match.gender
            if(this.model.match.date_time){
              // var tmp_date = moment.tz(this.model.match.date_time, this.time_zone_local)
              let tmp_time = new Date(this.model.match.date_time);
              this.date_start = tmp_time
              this.time_start = tmp_time
            }
            this.currency_code = this.model.match.currency_code
            this.participation_fee = this.model.match.participation_fee
            if(this.model.match.competition_clubs_id && this.model.match.competition_clubs){
              this.list_opponent = [{
                id : this.model.match.competition_clubs.id,
                name : this.model.match.competition_clubs.club_name
              }]
              this.opponent = this.model.match.competition_clubs.id
            }else{
              if(this.model.match.name_club_competition){
                this.list_opponent = [{
                  id : "id_tmp",
                  name : this.model.match.name_club_competition
                }]
                this.opponent = "id_tmp"
              }
            }
          }
          this.caption = this.model.caption
          break;
        case 'SCOUT_CLUB_TEAM_MEMBER':
          this.listOperatingTime();
          if(this.model.clubs){
            this.clubs_name = this.model.clubs.club_name
          }
          this.title = this.model.title
          this.number_recruit = this.model.number_recruit
          this.gender = this.model.gender
          this.caption = this.model.caption
          this.currency_code = this.model.currency_code
          this.participation_fee = this.model.participation_fee
          this.schedule = this.model.schedule
          this.about_club = this.model.abbout_club
          var operating_time = []
          if(this.model.post_operating_time){
            for (let i = 0; i < this.model.post_operating_time.length; i++) {
              const ot = this.model.post_operating_time[i].operating_time;
              operating_time.push({
                id : ot.id,
                name : ot.operating_time_lang[0].name,
              })
            }
          }
          this.operating_time_show = operating_time
          break;
        case 'APPLYING_TO_JOIN':
          this.listOperatingTime();
          await this.listCountry();
          var country_id = this.model.country_id ? this.model.country_id : 1;
          this.country_id = country_id
          this.title = this.model.title
          this.age = this.model.age ? this.model.age*1 : 1
          this.gender = this.model.gender
          this.about_yourself = this.model.about_yourself
          var operating_time_join = []
          if(this.model.post_operating_time){
            for (let i = 0; i < this.model.post_operating_time.length; i++) {
              const ot = this.model.post_operating_time[i].operating_time;
              operating_time_join.push({
                id : ot.id,
                name : ot.operating_time_lang[0].name,
              })
            }
          }
          this.operating_time_show = operating_time_join
          if(country_id && country_id > 0){
            var post_main_area = this.model.post_main_area ? this.model.post_main_area : []
            var list_state= []
            if(post_main_area.length > 0)
            for (let i = 0; i < post_main_area.length; i++) {
              const e = post_main_area[i];
              if(!list_state[e.province_id]){
                list_state[e.province_id] = {
                  id : e.province_id,
                  district_ids: e.district_id ? [e.district_id]: []
                }
              }else{
                if(list_state[e.province_id].district_ids.length > 0){
                  list_state[e.province_id].district_ids.push(e.district_id)
                }
              }
            }
            // console.log("list_state===",list_state)
            await this.listProvice('data',list_state)
          }
          break;
        case 'POST_ON_MY_CLUB':
          this.listNumaberOfPlayer();
          this.attendance_check = this.model.attendance_check ? this.model.attendance_check : false
          if(this.model.clubs){
            this.clubs_name = this.model.clubs.club_name
          }
          if(this.model.match){
            if(this.model.match.stadium){
              this.stadium_name = this.model.match.stadium.name
            }
            this.number_of_player_id = this.model.match.number_of_player_id
            this.gender = this.model.match.gender
            var match_label = ''
            if(this.model.match.date_time){
              // var tmp_date = moment.tz(this.model.match.date_time, this.time_zone_local)
              let tmp_time = new Date(this.model.match.date_time);
              match_label = moment.tz(tmp_time, this.time_zone_local).format("ll hh:mm A")
              this.date_start = tmp_time
              this.time_start = tmp_time
            }
            if(match_label !== ''){
              match_label += '-' + this.stadium_name
            }else{
              match_label = this.stadium_name
            }
            this.list_match = [{id : this.model.match.id,label : match_label}]
            this.match = {id : this.model.match.id,label : match_label}
            if(this.model.match.competition_clubs_id && this.model.match.competition_clubs){
              this.list_opponent = [{
                id : this.model.match.competition_clubs.id,
                name : this.model.match.competition_clubs.club_name
              }]
              this.opponent = this.model.match.competition_clubs.id
            }else{
              if(this.model.match.name_club_competition){
                this.list_opponent = [{
                  id : "id_tmp",
                  name : this.model.match.name_club_competition
                }]
                this.opponent = "id_tmp"
              }
            }
          }
          this.caption = this.model.caption
          break;
        
        case 'SHOWING_OFF_YOUR_EQUIPMENT':
          if(this.model.clubs){
            this.clubs_name = this.model.clubs.club_name
          }
          this.caption = this.model.caption
          // console.log("tag")
          if(this.model.tag){
            var tag_tmp = this.model.tag
            tag_tmp = tag_tmp.slice(1);
            var arr = tag_tmp.split("#");
            var tags = []
            for (let ta = 0; ta < arr.length; ta++) {
              tags.push({text: arr[ta]})
            }
            this.tags = tags
          }
          break;
        case 'QUESTION':
        case 'LIFE':
        case 'MATCH':
          if(this.model.clubs){
            this.clubs_name = this.model.clubs.club_name
          }
          this.caption = this.model.caption
          break;
        default:
          break;
      }
      
      this.active = this.model.active
      if (!this.$commonFuction.isEmpty(this.model.img_club)) {
        for (let n = 0; n < this.model.img_club.length; n++) {
          const elem = this.model.img_club[n];
          let url =elem.url
          let split = url.split('/')
          let fileName = split[split.length - 1]
          let obj = {'name': fileName, 'file': '', 'objectURL': url,type:'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
          this.img_club.push(obj)
        }
      }
    }
    
  },
  methods: {
    async ChangeOperating(){
      // console.log("OOOOOOK",this.operating_time)
      var id = this.operating_time.id ? this.operating_time.id : null
      var tmp = this.operating_time_show
      if(id){
        var check = false
        for (let i = 0; i < tmp.length; i++) {
          if(id == tmp[i].id){
            check = true
            break;
          }
        }
        if(check == false){
          tmp.push(this.operating_time);
          tmp = tmp.sort((a,b)=> (a.id > b.id ? 1 : -1))
        }
      }
      this.operating_time_show = tmp;
      this.operating_time = null
      // console.log("operating_time_show",tmp)
    },
    async listOperatingTime(){
      var {data} = await this.$apollo.query({
        query: DataServices.getList('operating_time',{"fields" : `id ordinal operating_time_lang(where: {lang: {_eq: "en"}}){lang name}`}),
        variables: {
          where_key: {
            deleted: {'_eq': false},
            active: {'_eq': true}
          },
          orderBy:{ordinal: 'asc'}
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        var tmp = []
        for (let i = 0; i < model.length; i++) {
          const e = model[i];
          tmp.push({
            id : e.id,
            name : e.operating_time_lang[0].name,
          })
        }
        this.list_operating_time = tmp;
      }else{
        this.list_operating_time = []
      }
    },
    async listNumaberOfPlayer(){
      var {data} = await this.$apollo.query({
        query: DataServices.getList('number_of_player',{"fields" : `id code`}),
        variables: {
          orderBy:{code: 'desc'}
        },
        fetchPolicy: "no-cache"
      })
      var model = data[Object.keys(data)];
      var tmp = []
      if (model.length > 0) {
        for (let i = 0; i < model.length; i++) {
          const e = model[i];
          tmp.push({
            id : e.id,
            code : e.code,
            label : e.code +' : '+e.code
          })
        }
      }
      this.list_number_of_player = tmp

    },
    async funtionDistrict(e,index){
      var check = e.target.checked;
      var data1 = this.list_district[index];
      var data = Object.assign({},data1);
      if(check == true){
        data.check = true
      }else{
        data.check = false
      }
      this.$set(this.list_district,index,data);
      var count = 0
      for (let i = 0; i < this.list_district.length; i++) {
        var d = this.list_district[i]
        if(d.check==true){
          count++
        }
      }
      if(count == this.list_district.length){
        this.$set(this,"checkAllDistrict",true)
      }else{
        this.$set(this,"checkAllDistrict",false)
      }
      // console.log("this.list_province",this.list_province)
      // console.log("this.list_province_last",this.list_province_last)

    },
    async SaveArea(){
      await this.updateShowData();
      this.list_province_last = this.list_province
      this.checkAllProvince_old = this.checkAllProvince
      this.showChooseMain = false
    },
    async CancelDistrict(){
      this.list_district = this.list_district_old.map(m => { return {...m}})
      for (let i = 0; i < this.list_province.length; i++) {
        const e = this.list_province[i];
        if(e.id == this.province_id_main){
          this.$set(this.list_province[i],"districts", this.list_district);
          break;
        }
      }
      this.showChooseMainDistrict = false
    },
    async Savedistrict(){
      for (let i = 0; i < this.list_province.length; i++) {
        var e = this.list_province[i];
        if(e.id == this.province_id_main){
          var count = 0;
          for (let j = 0; j < this.list_district.length; j++) {
            const d = this.list_district[j];
            if(d.check == true){
              count++
            }
          }
          e.total_choose = count
          e.districts = this.list_district
          // console.log(this.list_district,this.list_district)
          this.$set(this.list_province,i, e);
          break;
        }
      }
      this.showChooseMainDistrict = false
      // console.log("this.list_province",this.list_province)
      // console.log("this.list_province_last",this.list_province_last)
    },
    async ShowDistrict(index){
      var data = this.list_province[index];
      this.province_id_main = data.id
      this.list_district= data.districts.map(m => { return {...m}})
      this.list_district_old= data.districts.map(m => { return {...m}})
      if(data.total_choose == data.total){
        this.checkAllDistrict = true
      }else{
        this.checkAllDistrict = false
      }
      this.showChooseMainDistrict = true
    },
    async updateShowData(data_show){
      var data = data_show ? data_show : this.list_province
      var main_active_area = [];
      for (let i = 0; i < data.length; i++) {
        const e = data[i];
        if(e.total_choose == e.total){
          main_active_area.push({
            id : e.id,
            is_all: true,
            district_id : null,
            label : "All "+e.name
          })
        }else if(e.total_choose > 0){
          for (let j = 0; j < e.districts.length; j++) {
            const d = e.districts[j];
            if(d.check == true){
              main_active_area.push({
                id : e.id,
                is_all: false,
                district_id : d.id,
                label : d.name + ', '+ e.name
              })
            }
          }
        }
      }
      this.main_active_area = main_active_area
      this.$set(this,"list_province_last",[...data])
      
    },
    async funtionProvince(e,index){
      var check = e.target.checked;
      var data1 = this.list_province[index];
      var data = Object.assign({},data1);
      if(check == true){
        data.total_choose = data.total
        this.total_province_choose++
        for (let i = 0; i < data.districts.length; i++) {
          data.districts[i].check = true
        }
      }else{
        data.total_choose = 0
        this.total_province_choose--
        // this.checkAllProvince = false
        for (let i = 0; i < data.districts.length; i++) {
          data.districts[i].check = false
        }
      }
      this.$set(this.list_province,index,data)
      if(this.total_province_choose == this.total_province){
        this.checkAllProvince = true
      }else{
        this.checkAllProvince = false
      }
      // console.log("list_province",this.list_province)
      // console.log("list_province_last",this.list_province_last)
    },
    async funtionProvinceCheckAll(e){
      var tmp = this.list_province_last.map(m => { return {...m}});
      var check = e.target.checked;
      // console.log("this.list_province_last",this.list_province_last)
      // console.log("this.list_province_last tmp", tmp)
      if(check){
        // console.log("this.list_province_last",this.list_province_last)
        this.checkAllProvince = true
        this.total_province_choose = this.list_province.length
        this.list_province.map(m => {
          if (m.total_choose == 0){
            m.total_choose = m.total;
            m.districts.map(d => {
              d.check = true;
            })
          }
        })
      } else{
        this.checkAllProvince = false
        this.total_province_choose = 0
        this.list_province.map(m => {
          m.total_choose = 0;
          m.districts.map(d => {
            d.check = false;
          })
        })
      }
      
      // this.list_province = data
      // var data = this.list_province;
      // this.$set(this,"list_province",this.list_province)
      this.$set(this, "list_province_last", tmp);
      // console.log("list_province",this.list_province)
      // console.log("list_province_last",this.list_province_last)
    },
    async funtionDistrictCheckAll(e){
      var tmp = this.list_province_last.map(m => { return {...m}});
      var check = e.target.checked;
      var data = this.list_district;
      if(check == true){
        this.checkAllDistrict = true
        this.total_district_choose = data.length
        this.list_district.map(m => {
          m.check = true;
        })
      }else{
        this.checkAllDistrict = false
        this.total_district_choose = 0
        this.list_district.map(m => {
          m.check = false;
        })
      }
      // this.$set(this,"list_district",this.list_district)
      this.$set(this, "list_province_last", tmp);
      // console.log("list_district",this.list_district)
      // console.log("list_province_last",this.list_province_last)
    },
    async showMainActive(){
      if(this.country_id){
      /**
       * Chọn All ngoài danh sách những cái đã chọn 0 thay đổi
       * Cái = 0 thì = all
       */
        var tmp = this.list_province_last.map(m => { return {...m}})
        this.$set(this,"list_province",tmp)
        // console.log("list_province",this.list_province_last)
        this.checkAllProvince = this.checkAllProvince_old;
        this.showChooseMain = true
      }else{
        this.showChooseMain = false
      }
    },
    async listProvice(key,map_data=[]){
      if(key=="change_country"){
        this.checkAllProvince = false;
        this.checkAllProvince_old = false
      }
      var country_id = this.country_id
      if(country_id){
        var {data} = await this.$apollo.query({
          query: DataServices.getList('province',{"fields" : `id ordinal province_lang(where: {lang: {_eq: "en"}}){lang name} districts(order_by: {ordinal: desc}){id district_lang(where: {lang: {_eq: "en"}}){lang name}}`}),
          variables: {
            where_key: {
              country_id: {'_eq': country_id},
              deleted: {'_eq': false},
              active: {'_eq': true}
            },
            orderBy:{ordinal: 'desc'}
          },
          fetchPolicy: "network-only"
        })
        var model = data[Object.keys(data)];
        if (model.length > 0) {
          var tmp = []
          for (let i = 0; i < model.length; i++) {
            const e = model[i];
            var districts = []
            var tmp_check = map_data[e.id] ? map_data[e.id] : null
            var total_choose = 0
            if(e.districts.length > 0){
              for (let k = 0; k < e.districts.length; k++) {
                const d = e.districts[k];
                var check_district = false
                if(tmp_check){
                  if(tmp_check.district_ids.length == 0 || tmp_check.district_ids.includes(d.id)){
                    check_district = true
                    total_choose++
                  }
                }
                districts.push({
                  id: d.id,
                  name: d.district_lang[0].name,
                  check : check_district,
                })
              }
            }
            tmp.push({
              id : e.id,
              name : e.province_lang[0].name,
              total_choose : total_choose,
              total : e.districts ? e.districts.length : 0,
              districts: districts,
            })
          }
          this.list_province_last = tmp;
          this.total_province = tmp.length
        }else{
          this.list_province_last = []
          this.total_province = 0
        }
      }else{
        this.list_province_last = []
      }
      this.updateShowData(tmp)
      // console.log("this.list_province_last",this.list_province_last)
    },
    async removeOperating(index){
      this.operating_time_show.splice(index, 1)
    },
    async removeAreas(index){
      var tmp = this.main_active_area[index];
      // console.log("tmptmptmp",tmp)
      for (let i = 0; i < this.list_province_last.length; i++) {
        var plast = this.list_province_last[i];
        var change = false;
        if(plast.id == tmp.id){
          if(tmp.is_all == true){
            plast.total_choose = 0
            for (let j = 0; j < plast.districts.length; j++) {
              plast.districts[j].check = false
            }
            change = true
          }else if(tmp.district_id){
            for (let j = 0; j < plast.districts.length; j++) {
              if(plast.districts[j].id == tmp.district_id){
                plast.districts[j].check = false;
                plast.total_choose--;
                change = true
                break
              }
            }
          }
        }
        if(change == true){
          this.$set(this.list_province_last,i,plast)
        }
      }
      this.main_active_area.splice(index, 1)
    },
    async listCountry() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('country',{"fields" : `id ordinal country_lang(where: {lang: {_eq: "en"}}){lang name}`}),
        variables: {
          where_key: {
            deleted: {'_eq': false},
            active: {'_eq': true}
          },
          orderBy:{ordinal: 'asc'}
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        var tmp = []
        for (let i = 0; i < model.length; i++) {
          const e = model[i];
          tmp.push({
            id : e.id,
            name : e.country_lang[0].name
          })
        }
        this.list_country = tmp;
      }else{
        this.list_country = []
      }
    },
    async listExperience() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('experience',{"fields" : `id ordinal experience_lang(where: {lang: {_eq: "en"}}){lang name}`}),
        variables: {
          where_key: {
            deleted: {'_eq': false},
            active: {'_eq': true}
          },
          orderBy:{ordinal: 'asc'}
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        var tmp = []
        for (let i = 0; i < model.length; i++) {
          const e = model[i];
          tmp.push({
            id : e.id,
            name : e.experience_lang[0].name
          })
        }
        this.list_experience = tmp;
      }else{
        this.list_experience = []
      }
    },
    funtionUpdate(e){
      var check = e.target.checked;
      this.active = check ? check : false
    },
    backToList() {
      this.$emit('back');
    },

    async validateData() {
      if(this.type_post == 'SCOUT_CLUB_TEAM_MEMBER'){
        var title = document.getElementById("title");
        if(this.title == '' || this.title == null){
          title.setCustomValidity("Title is not empty");
        }else{
          title.setCustomValidity("");
        }
        var participation_fee = document.getElementById("participation_fee");
        var fee = this.participation_fee ? this.participation_fee*1 : 0
        if(fee >= 0){
          participation_fee.setCustomValidity("");
        }else{
          if(fee < 0){
            participation_fee.setCustomValidity("Participation fee cannot be negative");
          }else{
            participation_fee.setCustomValidity("Participation fee is not empty");
          }
        }
        
        var operating_time_va = document.getElementById("operating_time_va");
        if(this.operating_time_show.length == 0){
          operating_time_va.setCustomValidity("Operating time is not empty");
        }else{
          operating_time_va.setCustomValidity("");
        }
      }else if(this.type_post == 'APPLYING_TO_JOIN'){
        var title_join = document.getElementById("title");
        if(this.title == '' || this.title == null){
          title_join.setCustomValidity("Title is not empty");
        }else{
          title_join.setCustomValidity("");
        }
        var operating_time_va_join = document.getElementById("operating_time_va");
        if(this.operating_time_show.length == 0){
          operating_time_va_join.setCustomValidity("Operating time is not empty");
        }else{
          operating_time_va_join.setCustomValidity("");
        }
        var list_state_ids = []
        var main_active_area = this.main_active_area ? this.main_active_area : []
        for (let i = 0; i < main_active_area.length; i++) {
          if(!list_state_ids.includes(main_active_area[i].id)){
            list_state_ids.push(main_active_area[i].id)
          }
          if(list_state_ids.length > 3){
            break;
          }
        }
        var province_city_va = document.getElementById("province_city_va");
        if(list_state_ids.length == 0){
          province_city_va.setCustomValidity("City/province is not empty");
        }else if(list_state_ids.length > 3){
          province_city_va.setCustomValidity("City/province max 3 areas");
        }else{
          province_city_va.setCustomValidity("");
        }
      }else if(this.type_post == 'SHOWING_OFF_YOUR_EQUIPMENT'){
        let count = 0
        if(this.caption){
          count++
        }
        if(this.tags && this.tags.length > 0){
          count++
        }
        if(this.img_club && this.img_club.length > 0){
          count++
        }
        if(count == 0){
          alert("Please enter at least one field");
          return false
        }
      }else if(this.type_post == 'LIFE' || this.type_post == 'MATCH' || this.type_post == 'QUESTION'){
        let count = 0
        if(this.caption){
          count++
        }
        if(this.tags && this.tags.length > 0){
          count++
        }
        if(this.img_club && this.img_club.length > 0){
          count++
        }
        if(count == 0){
          alert("Please enter at least one field");
          return true
        }
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }

    },
    convertPhone(numberPhone) {
      var phone = numberPhone
      if (numberPhone[0] === '0') {
        phone = phone.substring(1);
      }
      phone = phone.replace(' ', '')
      phone = '+84' + phone
      return phone
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }
      var main_active_area = this.main_active_area ? this.main_active_area : []
      // console.log("main_insert==",main_insert)
      var params = {
        type : this.type_post,
        time_start : this.time_start,
        date_start : this.date_start,
        main_active_area : main_active_area,
        active : this.active,
        country_id :this.country_id,
        number_of_player_id : this.number_of_player_id,
        gender : this.gender,
        participation_fee : this.participation_fee,
        currency_code : this.currency_code,
        caption : this.caption,
        img_club : this.img_club,
        img_club_deleted : this.img_club_deleted,
        abbout_club : this.about_club,
        post_operating_time : this.operating_time_show,
        schedule : this.schedule,
        number_recruit : this.number_recruit,
        title : this.title,
        age : this.age,
        tags : this.tags,
        about_yourself : this.about_yourself,
      }
      console.log("params", params)
      this.$emit('save', params);
    
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if(files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF']
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split('.').pop())) {
            alert("Please upload a maximum of " + this.maxFiles + " photos");
            return;
          }
        }
        if (files.length + this.img_club.length > this.maxFiles) {
          alert("The maximum number of images is " + this.maxFiles + " images");
        } else {
          var arrTemp = [], arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }
          
          if (arrFiles.length > 0) {
            alert("Your image is over 500MB");
          } else {
            this.img_club = this.img_club.concat.apply(this.img_club, arrTemp);
          }
        }
      }
    },
    onFileClear(index,key) {
      if(key=='img_club'){
        let img = this.img_club[index];
        this.img_club.splice(index, 1);
        if (img.file === '') {
          this.img_club_deleted.push(img)
        }
      }
    },
  },

}
</script>

<style lang="scss">
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .p-col-width-a{
    max-width: 600px
  }
  .in-d {
    font-weight: 700;
  }
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
  }
  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #ccc;
  }
  .checkmark1 {
    position: absolute;
    top: 8px;
    left: 4px;
    height: 20px;
    width: 20px;
    background-color: #ccc;
    cursor: pointer;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: #e95d57;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .container input:checked ~ .checkmark{
    background-color:#E73725 !important; ;
  }
  .cus-tags{
    border-radius: 18px;
    padding: 8px;
    margin-right: 10px;
    background-color:#F2F3F7;
  }
  .cs-tag {
    padding: 10px 12px 10px 0px;
  }
  .cs-icon {
    color : #666666;
    padding-right: 4px;
    cursor: pointer;
  }
  .cs-icon-right {
    cursor: pointer;
  }
  .cs-text-right {
    color : #666666;
    float: right;
  }
  .custom-div{
    width: 500px;
    padding: 6px 6px 0px 30px;
    
  }
  .custom-div-check {
    border-width: 1px;
    border-style: solid;
  }
  .container-1 {
    display: block;
    position: relative;
    padding-left: 35px;
  }
  /* Hide the browser's default checkbox */
  .container-1 input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }
  
  /* On mouse-over, add a grey background color */
  .container-1:hover input ~ .checkmark1 {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container-1 input:checked ~ .checkmark1 {
    background-color: #e95d57;
  }
  /* Show the checkmark when checked */
  .container-1 input:checked ~ .checkmark1:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container-1 .checkmark1:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .container-1 input:checked ~ .checkmark1{
    background-color:#E73725 !important; ;
  }
  .cus-lab {
    cursor: pointer;
  }
  .container-1 .checkmark1:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .container-1 input:checked ~ .checkmark1{
    background-color:#E73725 !important; ;
  }
  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container-1 input:checked ~ .checkmark1 {
    background-color: #e95d57;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark1:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container-1 input:checked ~ .checkmark1:after {
    display: block;
  }

  .cusss .p-dialog-header-icons {
    display: none;
    align-items: center;
  }
  .class-tr {
    border: 3px solid red;
  }
  .text-cus {
    color : red;
    font-weight: 500;
  }
  .cus-vue-tags-input{
    max-width: 600px !important;
  }
</style>
